import { SkeletonMainLayout } from 'src/modules/common/skeletons/SkeletonMainLayout/SkeletonMainLayout.tsx';
import { UserInputKindQuery, UserInputKindQueryVariables } from 'src/generated/operations.ts';
import { NoData } from 'src/modules/common/components/NoData/NoData.tsx';
import { Suspense, useContext, useMemo } from 'react';
import { UserInputPage } from 'src/modules/user-input/UserInputPage.tsx';
import { Query } from 'src/modules/common/components/Query/Query.tsx';
import { getHomePageConfig } from 'src/modules/home/HomePageMapping.ts';
import { getValvesPageConfig } from 'src/modules/valves/ValvesPageMapping.ts';
import { ConfigContext } from 'src/configContext.ts';
import { composeFilter } from 'src/utils/composeFilter.ts';
import { useFilterLogic } from 'src/modules/common/hooks/useFilterLogic.ts';
import { useUserInputState } from 'src/modules/user-input/useUserInputState.ts';

export const PrefetchUserInputKind = () => {
    const { userSettings } = useContext(ConfigContext);
    const pageConfig = useMemo(() => getHomePageConfig(userSettings.currentRegion), [userSettings]);
    const valvesPageConfig = useMemo(() => getValvesPageConfig(userSettings.currentRegion), [userSettings]);
    if (pageConfig === null || valvesPageConfig === null) {
        throw new Error('No Page Config!');
    }

    const {
        searchParams,
    } = useUserInputState(valvesPageConfig.filterConfig);

    const [filter] = useFilterLogic(pageConfig.filterConfig, searchParams);

    const variables = useMemo(() => ({
        variables: {
            filter: composeFilter(pageConfig.filterConfig, filter, userSettings.currentLocale),
            region: userSettings.currentRegion,
        },
    }), [filter, pageConfig.filterConfig, userSettings.currentLocale, userSettings.currentRegion]);

    return (
        <Suspense fallback={<SkeletonMainLayout/>}>
            <Query<UserInputKindQuery, UserInputKindQueryVariables>
                query={pageConfig.kindQuery}
                variables={variables}
            >
                {({ data }) => {
                    if (data === undefined) {
                        return <SkeletonMainLayout/>;
                    }

                    if (!data) {
                        return <NoData/>;
                    }
                    return <UserInputPage data={data}/>;
                }}
            </Query>
        </Suspense>
    );
};
